<template>
  <v-app class="home-page">
    <StoreHeader />

    <main>
      <HomeSectionRenderer
        v-for="section in visibleSections"
        :key="section.section_key || section.id"
        :section="section"
      />
    </main>

    <v-footer class="site-footer" padless>
      <v-container class="footer-content">
        <div>
          <strong class="footer-brand">{{ site.site_name || 'Tu tienda' }}</strong>
          <p>{{ site.tagline }}</p>
        </div>
        <div class="footer-contact">
          <span v-if="contact.address"><v-icon small dark>mdi-map-marker-outline</v-icon>{{ contact.address }}</span>
          <span v-if="contact.phone"><v-icon small dark>mdi-phone-outline</v-icon>{{ contact.phone }}</span>
          <span v-if="contact.email"><v-icon small dark>mdi-email-outline</v-icon>{{ contact.email }}</span>
        </div>
      </v-container>
      <div class="footer-bottom">© {{ currentYear }} {{ site.site_name || 'Tu tienda' }}</div>
    </v-footer>
  </v-app>
</template>

<script>
import StoreHeader from '@/components/store/StoreHeader.vue';
import HomeSectionRenderer from '@/components/home/HomeSectionRenderer.vue';
import { loadSiteConfig, siteState } from '@/site/siteConfig';

export default {
  name: 'HomeView',
  components: { StoreHeader, HomeSectionRenderer },
  computed: {
    site() { return siteState.data.site || {}; },
    contact() { return this.site.contact || {}; },
    currentYear() { return new Date().getFullYear(); },
    visibleSections() {
      return (siteState.data.sections || [])
        .filter(section => section.enabled !== false)
        .slice()
        .sort((a, b) => Number(a.sort_order || 0) - Number(b.sort_order || 0));
    },
  },
  mounted() {
    loadSiteConfig(true).catch(() => {});
  },
};
</script>

<style scoped>
.home-page{background:var(--site-bg,#fff)!important;color:var(--site-text,#111827)}main{min-height:60vh}.site-footer{display:block!important;color:#e2e8f0!important;background:var(--site-secondary,#111827)!important}.footer-content{display:grid;grid-template-columns:1fr 1fr;gap:40px;padding-top:52px;padding-bottom:42px}.footer-brand{display:block;margin-bottom:8px;color:#fff;font-family:var(--site-heading-font);font-size:1.55rem}.footer-content p{margin:0;color:#94a3b8}.footer-contact{display:flex;flex-direction:column;align-items:flex-end;gap:10px}.footer-contact span{display:flex;align-items:center;gap:8px}.footer-bottom{width:100%;padding:16px;text-align:center;color:#94a3b8;border-top:1px solid rgba(255,255,255,.1)}
@media(max-width:700px){.footer-content{grid-template-columns:1fr}.footer-contact{align-items:flex-start}}
</style>
